// extracted by mini-css-extract-plugin
export default {"para":"Navbar_para__kMZ6+","small":"Navbar_small__6bnNm","link":"Navbar_link__61lqP","spans":"Navbar_spans__CJHBr","cont":"Navbar_cont__af7lg","lists":"Navbar_lists__hqFOL"};